import { render, staticRenderFns } from "./interestSwiper.vue?vue&type=template&id=668e35e8&"
import script from "./interestSwiper.vue?vue&type=script&lang=js&"
export * from "./interestSwiper.vue?vue&type=script&lang=js&"
import style0 from "./interestSwiper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/show/index/interestSwiper.vue
// module id = null
// module chunks = 